const binding = { modules: {}, dataActions: {} };

    (binding.modules['dobbies-cookies-information'] = {
        c: () => require('partner/modules/dobbies-cookies-information/dobbies-cookies-information.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dobbies-cookies-information',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dobbies-cookies-information'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|dobbies-cookies-information|dobbies-cookies-information'] = {
                c: () => require('partner/modules/dobbies-cookies-information/dobbies-cookies-information.view.tsx'),
                cn: '__local__-__local__-dobbies-cookies-information'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };